import { render, staticRenderFns } from "./qycgindex.vue?vue&type=template&id=650f7678&scoped=true&"
import script from "./qycgindex.vue?vue&type=script&lang=js&"
export * from "./qycgindex.vue?vue&type=script&lang=js&"
import style0 from "./qycgindex.vue?vue&type=style&index=0&id=650f7678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f7678",
  null
  
)

export default component.exports